import React, { useEffect, useState } from 'react';
import {Navigate} from 'react-router-dom';
import { useSelector } from "react-redux";
import ResponsiveDrawer from '../components/ResponsiveDrawer';
import CircularLoading from "../components/CircularLoading";
import { ref, get, getDatabase } from "firebase/database";

function matchUser(permit, usertype){
    let permitions = permit? permit.split(',') : [];
    let permitted = false;
    for(let i=0;i<permitions.length;i++){
        permitted = usertype === permitions[i]?true:false
        if(permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ permit, permissionKey, children }) {
    const auth = useSelector(state => state.auth);
    const [checkedAuth,setCheckedAuth] = useState(false);
    const [checkedPermission,setCheckedPermission] = useState(false);
    const [hasRoutePermission,setHasRoutePermission] = useState(true);
    const database = getDatabase();

    useEffect(()=>{
        if(auth.profile && auth.profile.uid){
            setCheckedAuth(true);
        }
        if(auth.error && auth.error.msg && !auth.profile){
            setCheckedAuth(true);
        }
    },[auth.profile,auth.error])

    useEffect(() => {
        const checkManagerPermission = async () => {
            if (!auth.profile || !auth.profile.uid) {
                setCheckedPermission(true);
                return;
            }
            if (auth.profile.role !== 'manager' || !permissionKey) {
                setHasRoutePermission(true);
                setCheckedPermission(true);
                return;
            }

            try {
                const managerRef = ref(database, "roles/manager/permissions");
                const snapshot = await get(managerRef);
                const permissions = snapshot.exists() ? snapshot.val() : {};
                setHasRoutePermission(permissions[permissionKey] === true);
            } catch (error) {
                setHasRoutePermission(false);
            }
            setCheckedPermission(true);
        };

        if (checkedAuth) {
            setCheckedPermission(false);
            checkManagerPermission();
        }
    }, [auth.profile, checkedAuth, database, permissionKey]);

    if (!checkedAuth || !checkedPermission) {
        return <CircularLoading/>
    }

    if (!auth.profile || !auth.profile.uid) {
        return <Navigate to="/login" />
    }

    if (!matchUser(permit,auth.profile.usertype)) {
        return <Navigate to="/login" />
    }

    if (!hasRoutePermission) {
        return <Navigate to="/dashboard" />
    }

    return(
        <ResponsiveDrawer>{children}</ResponsiveDrawer>
    )
}

export default ProtectedRoute;
